export enum FindByIpServiceResponseResultType {
  NO_RESULT = 'NO_RESULT',
  ONE_RESULT = 'ONE_RESULT',
  MULTIPLE_RESULTS = 'MULTIPLE_RESULTS',
}
